import { render, staticRenderFns } from "./StepFeatures.vue?vue&type=template&id=455aff45&scoped=true"
import script from "./StepFeatures.vue?vue&type=script&lang=js"
export * from "./StepFeatures.vue?vue&type=script&lang=js"
import style0 from "./StepFeatures.vue?vue&type=style&index=0&id=455aff45&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455aff45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455aff45')) {
      api.createRecord('455aff45', component.options)
    } else {
      api.reload('455aff45', component.options)
    }
    module.hot.accept("./StepFeatures.vue?vue&type=template&id=455aff45&scoped=true", function () {
      api.rerender('455aff45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/steps/StepFeatures.vue"
export default component.exports